export default __webpack_public_path__ + "static/media/comportementConduite.cbc3bed4.png";